<template>
    <div style="padding: 20px 0px 0px 20px;">

    <el-form style="display: flex;flex-wrap: wrap;">
          <el-form-item label="任课老师:" style="display: flex;width: 33%;">
              <el-select placeholder="请选择任课l老师" v-model="input1" style="width: 100%" clearable filterable>
                  <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
              </el-select>
          </el-form-item>


          <el-form-item label="提交人:" style="display: flex;width: 33%;">
              <el-select placeholder="请选择提交人" v-model="input2" style="width: 100%" clearable filterable>
                  <el-option   v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
              </el-select>
          </el-form-item>



          <el-form-item label="审批状态:" style="display: flex;width: 33%;">
              <el-select placeholder="请选择审批状态" v-model="input3" style="width: 100%" clearable filterable>
                  <el-option   v-for="item in optionList3"  :key="item.id"  :value="item.id" :label="item.name"></el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="所在地域:"  style="display: flex;width: 33%;">
            <el-select v-model="input5" clearable filterable placeholder="请选择所在地域"  style="width: 100%;">
                <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue" :value="item.dictType"></el-option>
            </el-select>
          </el-form-item>

        <el-form-item label="上课日期:" style="display: flex;margin-right: 20px;">
            <el-date-picker
            v-model="createTimeStart"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择开始时间"
            style="width: 200px;"
            ></el-date-picker>
            <span style="margin: 0px 10px;">至</span>
            <el-date-picker
            v-model="createTimeEnd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择结束时间"
            style="width: 200px;"
            ></el-date-picker>
        </el-form-item>

        <el-form-item label="创建日期:" style="display: flex;margin-right: 20px;">
            <el-date-picker
            v-model="createTimeStart1"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择开始时间"
            style="width: 200px;"
            ></el-date-picker>
            <span style="margin: 0px 10px;">至</span>
            <el-date-picker
            v-model="createTimeEnd1"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择结束时间"
            style="width: 200px;"
            ></el-date-picker>
        </el-form-item>


          <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
              <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
              <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
          </div>

      </el-form>


      <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
          <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
          <el-table-column prop="courseDate" label="上课日期" show-overflow-tooltip width="180"></el-table-column>
          <el-table-column prop="courseStartTime" label="开始时间" show-overflow-tooltip width="180"></el-table-column>
          <el-table-column prop="courseEndTime" label="结束时间" show-overflow-tooltip width="180"></el-table-column>
          <el-table-column prop="teacherName" label="任课老师" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="courseStatus" label="排课状态" show-overflow-tooltip>
            <template slot-scope="scope">
                  <div v-if="scope.row.courseStatus === 1">实际课</div>
                  <div v-if="scope.row.courseStatus === 2">预排课</div>
            </template>
          </el-table-column>
          <el-table-column prop="synchronizationStatus" label="同步状态" show-overflow-tooltip>
            <template slot-scope="scope">
                  <div v-if="scope.row.synchronizationStatus === 0">未同步</div>
                  <div v-if="scope.row.synchronizationStatus === 1">已同步</div>
            </template>
          </el-table-column> -->
          <el-table-column prop="commitName" label="提交人" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="创建日期" show-overflow-tooltip width="180"></el-table-column>
          <el-table-column prop="auditStatus" label="审批状态" show-overflow-tooltip>
            <template slot-scope="scope">
                  <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);" v-if="scope.row.auditStatus === 0">待审批</div>
                  <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);" v-if="scope.row.auditStatus === 1">驳回</div>
                  <div style="display: flex;justify-content: space-around;color:rgb(23 226 31);" v-if="scope.row.auditStatus === 2">已完成</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="200">
              <template slot-scope="scope">
                  <div style="display: flex;justify-content: space-around;">
                      <el-button type="text" :style="{
                        color: scope.row.auditStatus === 2  || scope.row.auditStatus === 1 ? 'rgb(176 180 182)' : '#00aaff'
                      }" :disabled="scope.row.auditStatus === 2 || scope.row.auditStatus === 1" @click="handleClickView('审批', scope.row)">审批</el-button>
                      <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button>
                  </div>
              </template>
          </el-table-column>
      </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageNum" :page-size="pageSize"
          layout="prev, pager, next,sizes, jumper" :total="total">
      </el-pagination>

      <CourseCancellationomponents
        v-if="CourseCancellationComponentsShow"
        :CourseCancellationComponentsType="CourseCancellationComponentsType"
        :CourseCancellationComponentsID="CourseCancellationComponentsID"
        ref="CourseCancellationomponents"
        @handleEmit="CourseCancellationhandleEmit"
        :CourseCancellationomponentsTypeDistinguish="CourseCancellationomponentsTypeDistinguish">
      </CourseCancellationomponents>


    </div>
</template>


    <script>
    import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
    import axios from "axios";
    import apiBaseUrl from "../../config/api";
    import CourseCancellationomponents from './CourseCancellationomponents.vue'
    import { getTeachers } from "@/api/fiveClassApi"


    export default {
        components:{
            CourseCancellationomponents
        },
        data() {
           return{

                createTimeEnd: '',
                createTimeStart: '',
                createTimeEnd1: '',
                createTimeStart1: '',

                optionList1:[],
                optionList2:[],
                optionList3:[{id:0,name:'待审批'},{id:1,name:'驳回'},{id:2,name:'已完成'}],

                input1:'',
                input2:'',
                input3:'',

                dataList:[],

                pageNum: 1,
                pageSize: 10,
                total: 0,


                CourseCancellationComponentsType: '',
                CourseCancellationComponentsID: '',
                CourseCancellationComponentsShow: false,
                CourseCancellationomponentsTypeDistinguish:'取消课消审批',

                input5:'',
                optionsListt:[
                    {dictValue:"北京", dictType:1 },
                    {dictValue:"深圳", dictType:2 },
                ],

           }
        },

        mounted(){
            getTeachers().then(res => {  this.optionList1 = res.data })
            axios.get(`${ apiBaseUrl }/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res)=>{ this.optionList2 = res.data.data })

            this.getApiList()

            // setInterval(()=>{
            //   this.getApiList()
            // },3000)

            
            axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
            { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
            }).then((res)=>{ this.optionsListt = res.data.data})
        },


        methods:{

            CourseCancellationhandleEmit(e){
                this.getApiList()
                this.CourseCancellationComponentsShow = e
            },

            searchBtns(){
                this.getApiList()
            },

            clearBtns(){
                this.input1 = ''
                this.input2 = ''
                this.input3 = ''
                this.input4 = ''
                this.input5 = ''

                this.createTimeStart = ''
                this.createTimeEnd = ''
                this.createTimeStart1 = ''
                this.createTimeEnd1 = ''   

                this.getApiList()
            },

            getApiList(){
                let data = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    teacherId: this.input1,
                    commitId: this.input2,
                    auditStatus: this.input3,
                    regionName:this.input5 || localStorage.getItem('cityTepy'),
                    createStartTime: this.createTimeStart1 ? this.createTimeStart1 + ' 00:00:00' : '',
                    createEndTime: this.createTimeEnd1 ? this.createTimeEnd1 + ' 23:59:59' : '',
                    courseDateStart: this.createTimeStart ? this.createTimeStart + ' 00:00:00' : '',
                    courseDateEnd: this.createTimeEnd ? this.createTimeEnd + ' 23:59:59' : '',
                }
                axios.post(`${apiBaseUrl}/cancelEnding/find`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                      if(res.data.code === 200){
                        let data = res.data.data
                        this.dataList = data.records
                        this.pageNum = data.current ? data.current : 0
                        this.pageSize = data.size ? data.size : 10
                        this.total = data.total ? data.total : 0

                        this.$message({ message:res.data.message, type: "success" });
                      }else{
                        this.$message.error(res.data.message)
                        }
                }).catch((err)=>{
                    this.$message.error(err)
                })
            },

            handleSizeChange(e){
                this.pagepageSizeNum = e
                this.getApiList()
            },

            handleCurrentChange(e){
                this.pageNum = e
                this.getApiList()
            },

            handleClickView(type,itme){
                this.CourseCancellationComponentsType = type
                this.CourseCancellationComponentsID = itme.id
                this.CourseCancellationComponentsShow = true

                this.$nextTick(() => {
                    this.$refs.CourseCancellationomponents.handleInit(itme.id)
                })
            },


        }

    }
    </script>


    <style scoped lang="less">

        .no-click {
           pointer-events: none;
        }


    </style>



// WEBPACK FOOTER //
// src/ApprovalManagement/CancelCourseClosureApproval.vue